import { Grid, Typography } from "@material-ui/core";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import ICommonFormProps from "../../../../../../yoello-lib/modules/dynamicForms/interfaces/ICommonFormProps";
import InfoComponent from "../../../../../info-component";
import { UserStatusEnum } from "../type";
import { getUserStatus } from "../util";
import { useStyles } from "./style";

const UserStatus = (props: ICommonFormProps) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const userStatusTooltip = useMemo(() => {
    switch (props?.formProps?.userStatus) {
      case UserStatusEnum.CONFIRMED.toString():
        return t("checkUserStatus.tooltips.confirmed");
      case UserStatusEnum.EXTERNAL_PROVIDER.toString():
        return t("checkUserStatus.tooltips.externalProvider");
      case UserStatusEnum.FORCE_CHANGE_PASSWORD.toString():
        return t("checkUserStatus.tooltips.forceChangePassword");
      case UserStatusEnum.RESET_REQUIRED.toString():
        return t("checkUserStatus.tooltips.resetRequired");
      case UserStatusEnum.UNCONFIRMED.toString():
        return t("checkUserStatus.tooltips.unconfirmed");
      default:
        return "";
    }
    // eslint-disable-next-line
  }, [props?.formProps?.userStatus]);

  if (props.formProps?.userStatus === undefined) return <></>;
  const { color, background, title } = getUserStatus(
    props?.formProps?.userStatus
  );

  return (
    <Grid
      container
      direction="row"
      xs={12}
      className={classes.userStatusDetails}
    >
      <Grid item xs={6} className="status">
        <Typography>
          {t("checkUserStatus.form.userStatus")}
          <InfoComponent tooltip={userStatusTooltip} />
        </Typography>
        <Typography
          className="userStatusBox"
          style={{
            background: background,
          }}
        >
          <Typography style={{ color: color }}>{title}</Typography>
        </Typography>
      </Grid>
      <Grid item xs={6} className="date">
        <Typography>{t("checkUserStatus.form.userCreationDate")}</Typography>
        <Typography>{props?.formProps?.CreatedOn}</Typography>
      </Grid>
    </Grid>
  );
};
export default UserStatus;
